







import { Component, Vue, Watch } from 'vue-property-decorator'
import Layout from '@/components/public/Layout.vue'
import { namespace } from 'vuex-class'

import { deleteQuery, getCookie, getLang } from '@/utils/index.ts'
import session from './utils/session'
import { CODE_KEY } from './utils/gop'

const appStore = namespace('app')

@Component({
  components: {
    Layout,
  },
})
export default class App extends Vue {
  private checkedTheme: string = 'theme-one'
  @appStore.State((state) => state.isLogin) private isLogin: boolean
  @appStore.State((state) => state.registerOpen) private registerOpen: boolean
  @appStore.State((state) => state.isRegister) private isRegister: boolean
  @appStore.State((state) => state.lang) private lang: string | null
  @appStore.Action('getConfig') private getConfig!: Function

  configState = false
  @Watch('$route')
  routechange(to: any, from: any) {
    if (this.isLogin) {
      this['$router'].push({ path: to.path }).catch(() => {
        return
      })
    } else {
      this['$router'].push({ path: '/' }).catch(() => {
        return
      })
    }
  }
  @Watch('isLogin', { immediate: false, deep: true })
  watchIsLogin(val: any, old: any) {
    if (val) {
      if (this.registerOpen) {
        if (!this.isRegister) {
          this['$router'].replace({ path: 'register' }).catch(() => {
            return
          })
        } else {
          this['$router'].push({ path: 'download' }).catch(() => {
            return
          })
        }
      }
    }
  }

  /**  methods */
  detailAccessToken() {
    const accessToken = this['$route'].query['access_token']
    if (!accessToken) return
    delete this['$route']['access_token']
    deleteQuery(['access_token'])
    // 把链接的token存入store代替链接获取
    this['$store'].commit('app/setValue', {
      key: 'accessToken',
      value: accessToken,
    })
  }
  getCode() {
    const responseCode = this['$route'].query['code']
    if (!responseCode) return
    delete this['$route']['code']
    deleteQuery(['code'])
    this['$store'].commit('app/setValue', {
      key: 'code',
      value: responseCode,
    })
  }
  /** */
  created(): void {
    this.detailAccessToken()
    this.getCode()
    let lang
    /** 新增一层处理 */
    // 需要隐藏token
    /**     ------      */
    const gameLang = this['$route'].query['lang']
    if (gameLang) {
      lang = getLang(gameLang)
    } else if (this.lang) {
      lang = this.lang
    } else {
      lang = getLang()
    }
    this.getConfig(lang).finally(() => {
      // 无视请求状态 等待接口完成加载页面
      this.configState = true
    })
    if (sessionStorage.getItem('store')) {
      this['$store'].replaceState(
        Object.assign({}, this['$store'].state, JSON.parse(sessionStorage.getItem('store') || '')),
      )
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this['$store'].state.app))
    })
    window.addEventListener('pagehide', () => {
      sessionStorage.setItem('store', JSON.stringify(this['$store'].state.app))
    })
  }
}
